import { render, staticRenderFns } from "./controllerDetails.vue?vue&type=template&id=422f0172&scoped=true"
import script from "./controllerDetails.vue?vue&type=script&lang=js"
export * from "./controllerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422f0172",
  null
  
)

export default component.exports